import { z } from "zod";

export const activityFilterSchema = z.object({
  q: z.string().optional(),
  entityName: z.string().optional(),
  activity: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  page: z.number().int().min(1).default(1),
  per_page: z.number().int().min(1).default(20),
});

export type ActivityFilterValues = z.infer<typeof activityFilterSchema>;

export const ENTITY_OPTIONS = [
  { value: "all", label: "Semua Modul" },
  { value: "sale", label: "Penjualan (Kopi & Roti)" },
  { value: "rider_sale", label: "Penjualan Rider" },
  { value: "expense", label: "Pengeluaran" },
  { value: "receivable_payment", label: "Pembayaran Piutang" },
  { value: "product", label: "Produk" },
  { value: "raw_material", label: "Bahan Baku" },
  { value: "uom", label: "Satuan" },
  { value: "unit_conversion", label: "Konversi Satuan" },
  { value: "rider", label: "Rider" },
  { value: "user", label: "User" },
  { value: "role", label: "Role" },
  { value: "workspace", label: "Workspace" },
  { value: "bonus_rule", label: "Aturan Bonus" },
] as const;

export const ACTION_OPTIONS = [
  { value: "all", label: "Semua Aksi" },
  { value: "create", label: "Tambah (Create)" },
  { value: "update", label: "Ubah (Update)" },
  { value: "delete", label: "Hapus (Delete)" },
] as const;
